import { createApp } from "vue"
import { createVuetify } from "vuetify"

// Vuetify
import {
	VContainer,
	VBtn,
	VRow,
	VCol,
	VCard,
	VCardTitle,
	VMenu,
	VProgressLinear,
	VProgressCircular,
	VAlert,
	VList,
	VSelect,
	VImg,
	VExpansionPanel,
	VExpansionPanels,
	VExpansionPanelText,
	VExpansionPanelTitle,
	VTextarea,
	VListItem,
	VCardText,
	VCardActions,
	VIcon,
	VTextField,
	VSpacer,
	VDivider,
} from "vuetify/components"

import { Ripple } from "vuetify/directives"

// Custom Components
import PPPCalculator from "./components/PppCalculator.vue"
//import NavbarMessage from "./components/NavbarMessage.vue"

export const vuetify = createVuetify({
	components: {
		VContainer,
		VBtn,
		VRow,
		VSelect,
		VCol,
		VTextarea,
		VMenu,
		VImg,
		VExpansionPanel,
		VExpansionPanels,
		VExpansionPanelText,
		VExpansionPanelTitle,
		VCard,
		VCardTitle,
		VProgressLinear,
		VProgressCircular,
		VAlert,
		VList,
		VListItem,
		VCardText,
		VCardActions,
		VIcon,
		VTextField,
		VSpacer,
		VDivider,
	},
	directives: {
		Ripple,
	},
	icons: {
		defaultSet: "mdi",
	},
})

// Styles
import "vuetify/styles"
import "../css/app.css"
import "@mdi/font/css/materialdesignicons.css"

const app = createApp({})

// Register Custom Components
app.component("ppp-calculator", PPPCalculator)
//app.component("navbar-message", NavbarMessage)

app.use(vuetify)

app.mount("#app")
